import React from "react";

export default function RoleCard({ option, checked, onToggle, disabled }) {
  if (!option) return null;
  const Icon = option.icon;
  const variant = option.accent === "warning" ? "ui-option--green" : "ui-option--blue";

  const handleToggle = (e) => {
    e?.preventDefault?.();
    onToggle?.();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onToggle?.();
    }
  };

  const handleCheckboxChange = (event) => {
    event.stopPropagation();
    onToggle?.();
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      aria-pressed={checked}
      disabled={disabled}
      className={`ui-option ${variant} w-100 text-start`}
    >
      <div className="ui-option__icon">
        {Icon ? <Icon size={22} /> : null}
      </div>
      <div className="ui-option__text">
        <div className="ui-option__title d-flex align-items-center gap-2">
          {option.label}
          <span className="form-switch d-inline-flex align-items-center" aria-hidden="true">
            <input
              type="checkbox"
              className="form-check-input"
              checked={checked}
              onChange={handleCheckboxChange}
              onClick={(event) => event.stopPropagation()}
              tabIndex={-1}
              style={{ transform: "scale(1.1)" }}
            />
          </span>
        </div>
        <div className="ui-option__subtitle">{option.desc}</div>
      </div>
      <div className="ui-option__chevron" />
    </button>
  );
}
